import { ApplicationRoutes } from '../constants/appRoutes';
import { RouteAuthenticationRequirement, RouteItem } from '@invara-dev/react-base';
import { Layout } from '../components/layout/layout';
import { AppRoles } from '../constants/appRoles';

export const SchedulingRoutes: RouteItem = {
  text: 'Schedule',
  allowedRoles: [AppRoles.CleaningAdmin, AppRoles.Admin, AppRoles.Manager],
  layout: <Layout containerProps={{ w: '100%' }} />,
  authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
  path: ApplicationRoutes.scheduling.calendar,
  async lazy() {
    const component = await import('../features/scheduling/Calendar/Calendar');
    return { Component: component.Calendar };
  }
};
